<div class="login-box">
  <div class="login-logo">
    <a routerLink="/"
      ><b>{{ appName }}</b></a
    >
  </div>
  <!-- /.login-logo -->
  <div class="card" *ngIf="!forgotPasswordStatus">
    <div class="card-body login-card-body">
      <p class="login-box-msg">You forgot your password? Here you can easily retrieve a new password.</p>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
        <div class="input-group mb-3">
          <input
            type="email"
            [ngClass]="{
              'is-invalid': forgotPasswordForm.get('Email').errors && forgotPasswordForm.get('Email').touched
            }"
            class="form-control"
            formControlName="Email"
            placeholder="Email"
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-envelope"></span>
            </div>
          </div>
          <div class="invalid-feedback" *ngIf="forgotPasswordForm.get('Email').hasError('required') && forgotPasswordForm.get('Email').touched">
            Please choose a Email
          </div>
          <div class="invalid-feedback" *ngIf="forgotPasswordForm.get('Email').hasError('Email') && forgotPasswordForm.get('Email').touched">
            Please provide valid Email
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button type="submit" class="btn btn-primary btn-block">Request new password</button>
          </div>
          <!-- /.col -->
        </div>
      </form>

      <p class="mt-3 mb-1">
        <a routerLink="/login">Login</a>
      </p>
      <p class="mb-0">
        <a routerLink="/register" class="text-center">Register a new membership</a>
      </p>
    </div>
    <!-- /.login-card-body -->
  </div>
  <div class="help-block" *ngIf="forgotPasswordStatus">
    <div class="alert alert-success alert-dismissible">
      <h5><i class="icon fas fa-check"></i> Congratulations!</h5>
      We sent a reset password email to <b>{{ forgotPasswordForm.get('Email').value }}</b
      >. Please click the reset password link to set your new password.
    </div>
    <div>
      <a routerLink="/login" class="btn btn-block btn-primary">Login</a>
    </div>
  </div>
  <div class="lockscreen-footer text-center"><span [innerHTML]="copyright"></span></div>
</div>
